/// 会員 (公開サイトのマイページ登録者 = 会員 Auth0 テナントのユーザー) の API クライアント。
///
/// 社内担当者を扱う `@shared/api/members` (`/api/admin/members`) とは別物。backend が
/// `site_members` で分けているのと同じ理由で、こちらは `site-member` で通す。
///
/// **読み取り専用**。backend (U9) は GET しか持たず、会員への書き込みは Phase 2 の
/// 3 層データモデルの担当なので、このモジュールにも GET 以外を置かない。
/// 戻りは `unknown` のまま返し、検証と型付けは domain の `parseSiteMemberPage` が行う (#471)。

import { api } from './client';

/// 会員を 1 ページ読む。
///
/// `page` は API と同じ **0 起点**。`perPage` は 1〜100 で、範囲外と走査窓
/// ((page + 1) × perPage > 1000) の超過は backend が 400 で弾く。
export function listSiteMembers(page: number, perPage: number): Promise<unknown> {
  const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
  return api.get(`/api/site-members?${params.toString()}`);
}
